import repository from "../Repository";

export default {
  async list(screenId) {
    return repository.post(
      "disaster_staff_delivery",
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async create(screenId, payload) {
    return repository.post("disaster_staff_delivery_detail_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return repository.patch("disaster_staff_delivery_detail_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return repository.patch(
      "disaster_staff_delivery_detail_ope/delete",
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
